"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _LoginControllerBase2 = require("../LoginControllerBase");

var _LoginControllerBase3 = _interopRequireDefault(_LoginControllerBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginLeadManagerController = function (_LoginControllerBase) {
  (0, _inherits3.default)(LoginLeadManagerController, _LoginControllerBase);

  function LoginLeadManagerController($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums) {
    "ngInject";

    (0, _classCallCheck3.default)(this, LoginLeadManagerController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginLeadManagerController.__proto__ || (0, _getPrototypeOf2.default)(LoginLeadManagerController)).call(this, $location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums));

    _this.sections = [{ name: 'Home', visible: true, text: 'Welcome to Lead Manager ... Europes #1 Lead Management Tool', bgClass: 'bg1' }, { name: 'What We Do', visible: false, text: 'Capture measure & manage every lead regardless of source', bgClass: 'bg2' }, { name: 'Contact Us', visible: false, text: 'Understand the best source of leads for your business', bgClass: 'bg3' }];

    _this.selectedSection = _this.sections[0];

    _this.initialize();
    return _this;
  }

  (0, _createClass3.default)(LoginLeadManagerController, [{
    key: "updateSection",
    value: function updateSection(index) {
      this.sections.map(function (s) {
        return s.visible = false;
      });
      this.selectedSection = this.sections[index];
      this.selectedSection.visible = true;
    }
  }]);
  return LoginLeadManagerController;
}(_LoginControllerBase3.default);

exports.default = LoginLeadManagerController;


// WEBPACK FOOTER //
// ./client/app/components/login/loginLeadManager/loginLeadManager.controller.js